/**
 * Param
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'param';

class Param extends Component {
    init() {
        const input = this.element.querySelector('input');
        if (input && input.dataset[componentName]) {
            const value = new URLSearchParams(window.location.search).get(input.dataset[componentName]);
            if (value) {
                input.value = value;
            } else {
                input.parentElement.remove();
            }
        }
    }
}

registerComponent(`.${componentName}`, Param);
